import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import axiosInstance from '../../../../../../../../store/axiosInstance';
import Header from '../../../../../RMS/Components/Layout/Header';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';



function PromptPage() {
  const [prompt, setPrompt] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!prompt.trim()) {
      setError('Please enter a career goal.');
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const response = await axiosInstance.post('/api/v1/career-gpt/user-prompt', { prompt});

      navigate('/career-gpt/skills', { state: { skills: response.data } });
    } catch (error) {
      setError('Error processing prompt: ' + (error.response?.data?.error || error.message));
    } finally {
      setLoading(false);
    }
  };

   const trendingKeywords = [
  "AI Developer", "Data Science", "Machine Learning", "Full Stack", "UX Design", "Data Analytics", "Blockchain", "Python", "Java", "Solidity", "JavaScript", "Rust", "SQL", "MONGO DB", "React JS",
  "Tensorflow", "Figma", "Power BI", "GITHUB", "AWS/GCP/Azure", "JIRA", "Premier PRO"
   ];


  return (

    <div>
   <div className="bg-black h-screen text-white overflow-hidden overflow-y-auto bg-cover">
         <div className="bg-Fabcbg bg-cover bg-center w-full h-full font-worksans">
           <Header />
           <div className="relative">
          <div className="absolute w-full flex justify-between z-0">
            <div
              style={{
                background:
                  'radial-gradient(50% 50% at 50% 50%, rgba(158, 110, 230, 0.28) 0%, rgba(158, 110, 230, 0) 100%)',
              }}
              className="w-[35rem] h-[35rem] opacity-45 blur rounded-full"
            ></div>
            <div
              style={{
                background:
                  'radial-gradient(50% 50% at 50% 50%, rgba(92, 195, 250, 0.28) 0%, rgba(92, 195, 250, 0) 100%)',
              }}
              className="w-[35rem] h-[35rem] opacity-45 blur rounded-full"
            ></div>
          </div>

            <main className="flex flex-col items-center justify-center text-center px-4 mt-16  pb-20">
        <h1 className="text-4xl font-bold">
          Welcome to <span className="text-[#FF2857]">CareerGPT</span>
        </h1>
           
        <p className="mt-7 text-sm max-w-2xl text-gray-300">
          CareerGPT by D5art is your AI-powered career compass—just enter a role and unlock an exciting,
          tailored roadmap to success!
        </p>

         <div className="bg-[#D9D9D91C] border border-white/65 rounded-2xl p-1.5 flex items-center w-[80%] mx-auto mt-12 backdrop-blur-md">
                       <input
                         type="text"
                          id="prompt"
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
                          placeholder="e.g., I want to become a Full Stack Developer"
            disabled={loading}
                         className="w-[75%] bg-transparent outline-none text-white flex-1 px-4 placeholder-[#8f8d94] placeholder:italic placeholder:text-xs text-sm"
                       />
                       <button
                        onClick={handleSubmit}
                         className={` flex items-center bg-gradient-to-r from-[#0051FF]/65 to-[#00E5FF]/65 text-white border border-[#51CBFF]/60 px-4 md:px-5 py-2 rounded-full text-sm font-medium ${
              loading ? 'opacity-50 cursor-not-allowed' : ''
            } `}
             disabled={loading}
                       >
                         <p className="md:block hidden"> {loading ? 'Searching...' : 'Search'}</p>
                         <span className="md:ml-2">
                           <FontAwesomeIcon icon={faMagnifyingGlass} />
                         </span>
                       </button>
                     </div>
          {error && <p className="text-red-500 text-sm italic mb-4 text-center mt-2 ">{error}</p>}

        <div className="flex gap-4 mt-6 z-30 ">
          <button className="bg-[#D9D9D91C] cursor-pointer border border-[#1B86D3] px-10 py-2 rounded-full hover:bg-[#3a3a54]/20 text-sm italic " >
            Assist Me
          </button>
          <button className=" underline cursor-pointer italic text-sm hover:underline">
            Get Help / Contact us
          </button>
        </div>

        <section className="mt-16 w-full max-w-6xl">
       <h2 className="text-sm text-left underline mb-7 italic ">Trending Searches:</h2>
          <div className="flex flex-wrap gap-5 justify-center z-30">
            {trendingKeywords.map((keyword, idx) => (
              <span
                key={idx}
                className="bg-[#D9D9D91C] cursor-pointer z-30 px-10 py-2 rounded-full text-sm hover:bg-[#3a3a54]/30 transition italic "
              >
                {keyword}
              </span>
            ))}
          </div>
        </section>
      </main>

      {/* <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
        <h1 className="text-2xl font-bold mb-6 text-center">Career Guidance GPT</h1>
        {error && <p className="text-red-500 mb-4 text-center">{error}</p>}
        <div>
          <label htmlFor="prompt" className="block text-sm font-medium text-gray-700">
            Enter Your Career Goal
          </label>
          <input
            type="text"
            id="prompt"
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
            placeholder="e.g., I want to become a Full Stack Developer"
            disabled={loading}
          />
          <button
            onClick={handleSubmit}
            className={`mt-4 w-full bg-indigo-600 text-white py-2 px-4 rounded-md hover:bg-indigo-700 transition-colors duration-200 ${
              loading ? 'opacity-50 cursor-not-allowed' : ''
            }`}
            disabled={loading}
          >
            {loading ? 'Submitting...' : 'Submit'}
          </button>
        </div>
      </div> */}


      </div>
      </div>
    </div>
    </div>

  );
}

export default PromptPage;